import { ActorStageName } from 'generated/graphql';
import { BehaviorSubject } from 'rxjs';



const __broadcaster = new BehaviorSubject<IAppEvent | null>(null);



export interface IEditInvestorCardArgs {
  type: 'editInvestorCard';
  id?: string;
  campaignId?: string;
}

export interface IEditActorStageModalArgs {
  type: 'editActorStageModal';
  actorStageName: ActorStageName;
}

export interface IEditCampaignModalArgs {
  type: 'editFundraisingCampaign';
  campaignId?: string;
}

export interface ICreateCampaignModalArgs {
  type: 'createFundraisingCampaign';
}

export interface ISaveNoteModalArgs {
  type: 'saveNoteModal';
  investorCardId?: string;
  id?: string;
}

export interface IEditAccessPassModalArgs {
  type: 'editAccessPass';
  accessPassId?: string;
}

export interface IAddSuperAdminModalArgs {
  type: 'addSuperAdmin';
}

export interface IEditUserModalArgs {
  type: 'editUserModal';
  siteUserId: string;
  companyProfileId: string;
  investorProfileId?: string;
}

export interface IConfirmModalArgs {
  type: 'confirm';
  title?: string;
  body?: string;
  onConfirm: () => void;
}

export interface INotifyModalArgs {
  type: 'notify';
  title: string;
  body: string;
}

export interface IUploadUsersModalArgs {
  type: 'uploadUsers';
  userType: 'investors' | 'startups';
}

export interface ICreateUserAccountModalArgs {
  type: 'createUserAccount';
  userId: string;
  defaultEmail: string;
}

export interface IEditInvestmentAreaModalArgs {
  type: 'editInvestmentArea';
  investmentAreaId: string;
}

export interface IUploadInvestmentAreasModalArgs {
  type: 'uploadInvestmentAreas';
}

export interface IManageDownloadLimitsModalArgs {
  type: 'manageDownloadLimits';
}

export type IModalEventArgs =
  | IEditInvestorCardArgs
  | IEditActorStageModalArgs
  | IEditCampaignModalArgs
  | IAddSuperAdminModalArgs
  | ISaveNoteModalArgs
  | IEditUserModalArgs
  | IConfirmModalArgs
  | INotifyModalArgs
  | IUploadUsersModalArgs
  | ICreateUserAccountModalArgs
  | IEditInvestmentAreaModalArgs
  | IUploadInvestmentAreasModalArgs
  | IManageDownloadLimitsModalArgs
  | ICreateCampaignModalArgs
  | IEditAccessPassModalArgs
  | 'close';



export interface IModalEvent {
  type: 'modal';
  args: IModalEventArgs;

  onClose?: () => void;
}



export interface IDownloadLimitSnackbarArgs {
  type: 'downloadLimit';
  subscriptionStatus?: string;
  currentDownloads: number;
  totalDownloads: number;
}

export interface IDownloadLimitReachedSnackbarArgs {
  type: 'downloadLimitReached';
}

export type ISnackbarEventArgs = IDownloadLimitSnackbarArgs
| IDownloadLimitReachedSnackbarArgs;



export interface ISnackbarEvent {
  type: 'snackbar';
  args: ISnackbarEventArgs;
}

export type IAppEvent = IModalEvent | ISnackbarEvent;



export function broadcast(event: IAppEvent) {
  __broadcaster.next(event);
}



export function observable() {
  return __broadcaster.asObservable();
}
